import { render, staticRenderFns } from "./Zitai.vue?vue&type=template&id=34b704c8&scoped=true&"
import script from "./Zitai.vue?vue&type=script&lang=js&"
export * from "./Zitai.vue?vue&type=script&lang=js&"
import style0 from "./Zitai.vue?vue&type=style&index=0&id=34b704c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b704c8",
  null
  
)

export default component.exports